/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import iconExport from '../../../../assets/images/icone_exportar_template.svg';

import TemplateBotModal from '../../../TemplateBotModal/index';
import { ItemsCreators } from '../../../../store/actions/items';
import { BotsCreators } from '../../../../store/actions/bots';
import {
  createTemplateBot,
  updateTemplateBot,
  getTemplateBot,
} from '../../../../store/actions/template-bot';
import { ConnectorsCreators } from '../../../../store/actions/connectors';

/**
 * Save template bot button component
 *
 * @param {*} props data used on this component
 */
const SaveTemplateBotButton = (props) => {
  const { bot, user, show, templateBotData, allItems, allConnectors } = props;
  const [showModal, setShowModal] = useState(false);

  /**
   * Wait for the bot id information and try to get the template bot from the current bot
   */
  useEffect(() => {
    if (bot?._id) {
      const { getTemplateBot } = props;
      getTemplateBot(bot._id);
    }
  }, [bot?._id]);

  const onClickSaveTemplateBot = (event) => {
    event.preventDefault();
    const { getTemplateBot } = props;
    getTemplateBot(bot._id);
    setShowModal(true);
  };

  return (
    <div
      className={
        user?.selectedCompany?.claim?.name !== 'Viewer'
          ? `menu-criador-item ${
              show === 'template-bot' && 'menu-criador-ativo'
            }`
          : `menu-criador-item op-user-menuleft ${
              show === 'template-bot' && 'menu-criador-ativo'
            }`
      }
    >
      <a href="#/" onClick={onClickSaveTemplateBot}>
        <img
          className="export-icon-template"
          alt="Salvar Template"
          src={iconExport}
        />
      </a>
      <div className="save-template-modal">
        <TemplateBotModal
          bot={bot}
          items={allItems}
          connectors={allConnectors}
          templateBotData={templateBotData}
          show={showModal}
          setShow={setShowModal}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    items: state.items.list,
    connectors: state.connectors.list,
    allItems: state.items.allItems,
    allConnectors: state.connectors.allConnectors,
    bot: state.bots.bot,
    templateBotData: state.templateBot.templateBotData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      ...ItemsCreators,
      ...ConnectorsCreators,
      ...BotsCreators,
      createTemplateBot,
      updateTemplateBot,
      getTemplateBot,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SaveTemplateBotButton);
